import { useQuery } from '@tanstack/react-query';
import axios from '../../axiosConfig';
import { GET_GENERAL_ORDERS_OPTIONS } from '../queries/GetOrdersList';

const fetchFiltersOptionsData = async ({ queryKey }) => {
  const [, { currentLine, token, field, viewOption }] = queryKey;

  try {
    const url = `/Order/GetFilterOptions/${encodeURIComponent(currentLine.ProdFamilyId)}?plantProdFamilyId=${encodeURIComponent(currentLine.PlantProdFamilyId)}&columnNameDistinct=${encodeURIComponent(field)}&ViewOption=${encodeURIComponent(viewOption)}&productName=${encodeURIComponent(currentLine.ProdFamilyName)}`;

    const response = await axios.get(url, {
      headers: { Authorization: token },
    });

    return response.data;
  } catch (error) {
    console.error('Error fetching filter options:', error);
    throw error;
  }
};

export const useGetOrdersFilterOptions = (params ) => {
  return useQuery({
    queryKey: [GET_GENERAL_ORDERS_OPTIONS, params ],
    queryFn: fetchFiltersOptionsData,
    enabled: !!params.token && params.enabled,
    retry: false,
  });
};
